// extracted by mini-css-extract-plugin
export var background = "ComponentBg-module--background--7066e";
export var bgWrapper = "ComponentBg-module--bgWrapper--eda16";